webpackJsonp([1],{

/***/ "0B/E":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"252","height":"101","viewBox":"0 0 252 101","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_v("Untitled")]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"fill":"#395441","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M12.1 73.9L8 60.4H6.8v13.4H0V42h6.7v12.7h1.4l4-12.7h7.3l-5.1 15.3 5.3 16.6zM33.5 68.1H28l-.8 5.8h-7L26.5 42h8.9l6.4 31.9h-7.4l-.9-5.8zm-3.1-16.6L29 61.6h3.7l-1.4-10.1-.4-3.4h-.1l-.4 3.4zM50.9 42l3.7 15.7.7 3.4h.1l.7-3.4L60 42h7.7v31.9h-6.2V60.7l.1-3.4h-.1l-.8 3.4-3.2 13.2h-4.3L50 60.7l-.8-3.4h-.1v16.5h-5.8V42zM86.2 67.3l-.2 6.6H70.8V42h14.7l.1 6.7h-8.1v5.6h6.6v6.3h-6.6v6.7zM102.9 60.2l4.4 13.7h-7.6l-3.1-12.3H95v12.3h-6.8V42h7.9c6.8 0 9.9 2.6 9.9 9.9.1 4.3-1 7.1-3.1 8.3zm-6.2-11.8h-1.5v7.4h1.5c1.9 0 2.5-.4 2.5-3.7 0-3.1-.7-3.7-2.5-3.7zM121.1 68.1h-5.5l-.8 5.8h-7L114 42h8.9l6.4 31.9h-7.4l-.8-5.8zm-3.2-16.6l-1.4 10.1h3.7l-1.4-10.1-.4-3.4h-.1l-.4 3.4zM139.4 73.9h-8.5V42h8.2c7.6 0 10.8 3.5 10.8 15.7.1 12.1-3 16.2-10.5 16.2zm.1-25.3h-1.8v18.8h1.8c2.5 0 3.4-.8 3.4-9.8 0-8-.8-9-3.4-9z"}})]),_c('path',{attrs:{"fill":"#395441","fill-rule":"nonzero","d":"M201.1 42h7v31.9h-7zM225.7 67.2l-.2 6.7h-14.1V42h6.9v25.2zM235.2 42l3.7 15.7.7 3.4h.1l.7-3.4 3.8-15.7h7.7v31.9h-6.2V60.7l.1-3.4h-.1l-.8 3.4-3.2 13.2h-4.3l-3.2-13.2-.8-3.4h-.1v16.5h-5.8V42zM190.8 48.8h8l-.1-6.8h-8.8c-.3.7-1.5 3.3-2.2 4.1-.9 1.1-2.9 4.1-3.3 4.8-.1.1-.2.4-.4.6v22.3h6.8V61.5h6.7V55h-6.7v-6.2z"}}),_c('g',{attrs:{"fill":"#FE5000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M4.4 83.1v.2c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v.2H3.2V81c0-.6-.4-1-1-1s-1 .4-1 1.1v2.3c0 .6.4 1.1 1 1.1s1-.4 1-1v-.2h1.2v-.2zM9.8 83.3c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v2.3zm-3.3 0c0 .6.4 1.1 1 1.1s1-.4 1-1.1V81c0-.6-.4-1.1-1-1.1-.7 0-1 .4-1 1.1v2.3zM15.4 85.3h-1l-2.2-4v4H11V79h1l2.2 3.9V79h1.1v6.3zM21 83.1v.2c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v.2h-1.2V81c0-.6-.4-1-1-1s-1 .4-1 1.1v2.3c0 .6.4 1.1 1 1.1s1-.4 1-1v-.2H21v-.2zM23.3 82.6v1.6H26v1.1h-3.9V79H26v1h-2.7v1.5h2.4v1.1zM27.2 79h2.2c1.3 0 2.2.8 2.2 2.1s-.9 2.1-2.2 2.1h-1v2.2h-1.2V79zm1.2 1v2.1h.9c.7 0 1.1-.4 1.1-1s-.4-1-1.1-1h-.9V80zM32 79h4.2v1h-1.5v5.3h-1.2V80H32z"}})]),_c('path',{attrs:{"fill":"#FE5000","fill-rule":"nonzero","d":"M39.9 86.4h-1.1V78h1.1z"}}),_c('g',{attrs:{"fill":"#FE5000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M47.4 83.1v.2c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v.2h-1.2V81c0-.6-.4-1-1-1s-1 .4-1 1.1v2.3c0 .6.4 1.1 1 1.1s1-.4 1-1v-.2h1.2v-.2zM52.8 83.3c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v2.3zm-3.3 0c0 .6.4 1.1 1 1.1s1-.4 1-1.1V81c0-.6-.4-1.1-1-1.1-.7 0-1 .4-1 1.1v2.3zM57.1 85.3l-.9-2.3h-1v2.3H54V79h2.2c1.3 0 2.2.8 2.2 2 0 .8-.4 1.4-1 1.8l1 2.6h-1.3v-.1zM55.2 80v1.9h.9c.7 0 1.1-.4 1.1-1s-.4-.9-1.1-.9h-.9zM59.6 79h2.2c1.3 0 2.2.8 2.2 2.1s-.9 2.1-2.2 2.1h-1v2.2h-1.2V79zm1.2 1v2.1h.9c.7 0 1.1-.4 1.1-1s-.4-1-1.1-1h-.9V80zM69.2 83.3c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v2.3zm-3.2 0c0 .6.4 1.1 1 1.1s1-.4 1-1.1V81c0-.6-.4-1.1-1-1.1-.7 0-1 .4-1 1.1v2.3zM73.6 85.3l-.9-2.3h-1v2.3h-1.2V79h2.2c1.3 0 2.2.8 2.2 2 0 .8-.4 1.4-1 1.8l1 2.6h-1.3v-.1zM71.7 80v1.9h.9c.7 0 1.1-.4 1.1-1s-.4-.9-1.1-.9h-.9zM75.4 85.3l1.9-6.3h1.3l1.9 6.3h-1.2l-.3-1.1h-2l-.3 1.1h-1.3zm1.8-2.2h1.5l-.7-2.7-.8 2.7zM80.4 79h4.2v1h-1.5v5.3h-1.2V80h-1.5zM86.7 82.6v1.6h2.7v1.1h-3.9V79h3.9v1h-2.7v1.5h2.4v1.1z"}})]),_c('path',{attrs:{"fill":"#FE5000","fill-rule":"nonzero","d":"M93.6 86.4h-1.1V78h1.1z"}}),_c('g',{attrs:{"fill":"#FE5000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M101 83.1v.2c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v.2h-1.2V81c0-.6-.4-1-1-1s-1 .4-1 1.1v2.3c0 .6.4 1.1 1 1.1s1-.4 1-1v-.2h1.2v-.2zM106.5 83.3c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v2.3zm-3.3 0c0 .6.4 1.1 1 1.1s1-.4 1-1.1V81c0-.6-.4-1.1-1-1.1-.7 0-1 .4-1 1.1v2.3zM108.8 81.3v4h-1.1V79h1l1.5 2.8 1.5-2.8h1v6.3h-1.2v-3.9l-1 1.9h-.7zM115.3 81.3v4h-1.1V79h1l1.5 2.8 1.5-2.8h1v6.3H118v-3.9l-1 1.9h-.7zM121.9 82.6v1.6h2.7v1.1h-3.9V79h3.9v1h-2.7v1.5h2.4v1.1zM128.8 85.3l-.9-2.3h-1v2.3h-1.2V79h2.2c1.3 0 2.2.8 2.2 2 0 .8-.4 1.4-1 1.8l1 2.6h-1.3v-.1zm-1.9-5.3v1.9h.9c.7 0 1.1-.4 1.1-1s-.4-.9-1.1-.9h-.9zM135.4 83.1v.2c0 1.3-.9 2.1-2.2 2.1-1.3 0-2.2-.8-2.2-2.1V81c0-1.3.8-2.1 2.2-2.1 1.3 0 2.2.8 2.2 2.1v.2h-1.2V81c0-.6-.4-1-1-1s-1 .4-1 1.1v2.3c0 .6.4 1.1 1 1.1s1-.4 1-1v-.2h1.2v-.2zM137.8 85.3h-1.2V79h1.2zM138.6 85.3l1.9-6.3h1.3l1.9 6.3h-1.2l-.3-1.1h-2l-.3 1.1h-1.3zm1.8-2.2h1.5l-.7-2.7-.8 2.7zM145.8 84.2h2.5v1.1h-3.7V79h1.2z"}})]),_c('path',{attrs:{"d":"M185.3 33.8s0-.1-.2-.5-.5-.7-1.3-1.8-4.3-4.5-4.8-5.1c-.5-.5-.4-.5-1.1-1.7-.7-1.2-3.4-3-5.3-4.1-2-1.1-3.2-1-3.2-1l-1.3-1.6.3-.3c.2-.2 1-.8 1.4-1.4.4-.6.5-1.7.6-2.3.1-.6.3-1 .4-1.3.2-.2.5-.8.5-1 .1-.2-.2-.2-.3-.2h-.5l.2-1c.1-.5.4-1.6.4-2.5 0-.9.1-1.1.1-1.8 0-.8.2-.9.2-.9s-.5-.5-.7-1c-.3-.4-.8-1.4-1.2-1.8-.4-.4-1.6-1.2-3.7-1.7-2.1-.4-2.6.2-4.2 1s-2 2.2-2.2 3.1c-.2.9-.1 2-.1 3.1.1 1.1-.3 1.6-.3 1.6s-.1-.1-.5-.3c-.4-.2-.3 0-.7.4-.3.4-.2.9-.2 1.1.1.2.2.7.4 1.4.1.7.4.8.5 1 .2.2.2.3.4.8s1.1.5 1.1.5l1.4 5.4h-.9c-.6 0-1.1.6-1.4.8-.3.2-.1 0-1.7.9-1.6.9-2 3.8-2 4.1 0 .3-.4.9-.6 1.4-.2.5.1 1.2-.2 1.9-.4.7-.6 2.2-.7 2.9-.1.7-.4 1.1-.7 2-.3.9 2.7 3.8 2.7 3.8l-.5 1c-.4.9-.7 2.5-1 4.2-.2 1.7-.8 2.6-1 3.1-.2.5-.8 4-.8 4.4 0 .5-.1 1.8 0 2.2.1.4 1.1 1.9 1.1 1.9l.2.6c.2.5 0 .3.9.9.5.3 2.4-.1 2.4-.1s.1.1.3.6c.2.5 1.6 1.1 1.6 1.1s-.1 8.2 0 9.4c0 1.3 1.1 1.2 1.1 1.2s0 .1-.1.2c0 .1-.3 1.3-.5 1.8s0 .6 0 .6-.1.1-.4.7c-.3.6.1 2 .2 2.5s.1 1.6.1 1.6-.1.1-.1.3c0 .1-.2 2.3-.2 2.6 0 .3-.8 3.2-1 4.1-.2.9-1.3 5.8-1.3 5.8-.2.8-1.9 3.2-1.9 3.2s-.2-.1-.4-.1-.6.1-.8.2c-.2.1-.6.9-.6.9s-.1 0-.4-.1c-.3 0-.3.1-.4.3-.1.2.2.4.2.4v.1c0 .1-.1.1-.3.1-.2 0-.2.1-.3.2-.1.2 0 .5 0 .5h-.2c-.2 0-.2.3-.3.6 0 .3-.1.1-.4.2-.3.1-.1.1-.2.5s-.1.5-.5.7c-.4.2-.8.8-.8.8h-.2c-.1 0-.3.1-.8.4-.5.3-.6.9-.6.9l-.1.1c-.1.1-.1.4-.1.8s0 .5 1.3 1.2c1.2.7 3.3.5 5.2.2 1.9-.3 3.2-1.6 3.7-2.1.5-.6 1.2-.8 1.9-1.3.8-.5.6-1.5.6-1.9 0-.4 0-.6-.1-1.5-.2-.9-.2-.5-.2-.8 0-.3-.2-.3-.2-.3s.3-1.3.6-2.2c.3-.9.8-2 1.2-2.8.4-.7 1.8-3.4 2.5-5s1-4.5 1-5.4c0-.9.1-1.8.1-2 0-.2-.2-.1-.2-.1s-.1-.7 0-1.5c0-.8.7-2.3.7-2.3s.6 0 1.4-.2c.7-.1 1-.2 1.3-.3.2-.1.3.1.6.2s1.3 0 1.3 0l1.1 1.1c.4.5 6.6 10.2 6.6 10.2s-.1 0-.3.1c-.2.1-.3.4-.6.7-.2.4-.4.3-.8.6-.3.3-.3 1.1-.4 1.6-.1.6-.5.7-1 1-.5.3 0 .4 0 .4v.2s-.4 0-.7.2c-.3.1-1.5.7-2 1-.5.3-.5.8-.4 1.6.1.8 1.6 1.3 3.5 1.1 1.9-.1 3.6-1 4.1-1.5.5-.5.7-.8 1.1-1.1.4-.3 2.5-1.6 3.6-2.4 1-.7 1.1-1.1 1.2-1.5.1-.5-.2-1-.4-1.2-.2-.3-.3-.2-.3-.2s-.1-.1-.1-.4c-.1-.2-1.1-1.3-1.4-1.6-.3-.3-.4-.1-.4-.1s-1.1-1.5-1.6-2.5-2.1-5-2.8-6.7c-.7-1.7-3.2-2.8-3.2-2.8l.7-9.7.3-.2c.3-.2.9-1 .9-1 .6-.9.5-3 .5-3l.5-.3c.3-.2 1.6-1.2 2.5-2 .2.3.5.7.5.9 0 .3-.5.5-.3.9s.7.8 1.3 1.2c.7.4.8.5.4 1.4-.4.9-2.2 3.2-2.4 3.7-.2.4-.4.7-.3.9.1.2.3.4-.2 1.1-.5.7-2.4 3.7-2.7 4.3-.3.6-.5.8-.5.8s-.4-.1-.4.1-.1.3.5.7c.6.3 1.5.9 1.6.9.1 0 .3-.1.3-.3 0-.2-.3-.2-.1-.5.1-.3 1.5-3.2 1.7-3.7.2-.5.9-2.1 1-2.8.1-.7-.1-.9.2-1.5.3-.6 1.5-2.4 1.7-2.7.2-.4.8-1.8.7-2.1 0-.3-.4-1-.8-1.5-.4-.4-.9-.6-.9-1.1 0-.5.2-.6-.2-1.1 0-.1-.1-.1-.1-.2 0 0 1.3-1.4 1.9-2 .5-.7 1.2-2.3 2-3.4s2.6-3.9 3.3-5.3c.6-1.4.6-2.5.7-2.9.1-.4.4-.3.5-.9-.4.3-4.8-3.7-4.8-3.7z","fill":"#395441"}})])])}}};

/***/ }),

/***/ "3aJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("E+l5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f77e3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("lOOt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f77e3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4L5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Overlayer',
	methods: {
		close: function close() {
			this.$parent.closeOverlayer();
			__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.delay(function () {
				return __WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].commit('setOverlayerDom', '');
			}, 800);
		}
	},
	computed: {
		insertDom: function insertDom() {
			return __WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].state.overlayer;
		}
	}
});

/***/ }),

/***/ "6x5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"grid grid--middle"},[_c('div',{staticClass:"grid__cell r1-2"},[_c('ul',{staticClass:"links"},_vm._l((_vm.menu),function(item, key){return _c('li',[_c('router-link',{attrs:{"to":item.anchor}},[_vm._v(_vm._s(item.name))])],1)}))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "70Zu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("i2i7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58abadc5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("j2gS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58abadc5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7IiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page"},[_vm._l((_vm.sections),function(section,index){return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('section',{class:'section',attrs:{"id":section.type}},_vm._l((section.childs),function(child,index){return _c(child.type,{key:child.type,tag:"component",attrs:{"content":child}})}))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AO5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_Hero___ = __webpack_require__("e0hc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__features_Details___ = __webpack_require__("3aJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__features_Movies___ = __webpack_require__("aoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__features_Columns___ = __webpack_require__("LAxe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__features_Gallery___ = __webpack_require__("xjBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__features_Slider___ = __webpack_require__("xMj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__features_Logoslider___ = __webpack_require__("70Zu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__features_Legals___ = __webpack_require__("DurA");
//
//
//
//
//
//
//
//
//
//
//
//






// components









/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Page',
	data: function data() {
		return {
			loading: false,
			error: null,
			views: []
		};
	},

	methods: {
		scrollToAnchor: function scrollToAnchor() {
			var _this = this;

			var scrollto = this.$router.currentRoute.query.scrollto || null;
			if (scrollto) {
				var anchor = document.querySelector('#' + scrollto) || null;
				if (anchor) setTimeout(function () {
					return _this.$parent.winScrollTo(anchor);
				}, 1100);
			}
		}
	},
	computed: {
		sections: function sections() {
			var views = [];
			__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].state.content, function (item, key) {
				views.push({
					type: key,
					childs: item
				});
			});
			return views;
		}
	},
	components: {
		hero: __WEBPACK_IMPORTED_MODULE_3__features_Hero___["a" /* default */],
		detail: __WEBPACK_IMPORTED_MODULE_4__features_Details___["a" /* default */],
		movies: __WEBPACK_IMPORTED_MODULE_5__features_Movies___["a" /* default */],
		columns: __WEBPACK_IMPORTED_MODULE_6__features_Columns___["a" /* default */],
		gallery: __WEBPACK_IMPORTED_MODULE_7__features_Gallery___["a" /* default */],
		slider: __WEBPACK_IMPORTED_MODULE_8__features_Slider___["a" /* default */],
		logoslider: __WEBPACK_IMPORTED_MODULE_9__features_Logoslider___["a" /* default */],
		legals: __WEBPACK_IMPORTED_MODULE_10__features_Legals___["a" /* default */]
	},
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		// Load Page Content
		var pathCollection = to.path.split("/").filter(function (res) {
			return res.length >= 1 ? true : false;
		});
		var id = pathCollection.join('/');
		//
		fetch(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* ABSPATH */] + '/' + id).then(function (response) {
			return response.json();
		}).then(function (body) {
			__WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].commit('insertPage', body);
			next(true);
		}).catch(next(false));
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		// Load Page Content
		var pathCollection = to.path.split("/").filter(function (res) {
			return res.length >= 1 ? true : false;
		});
		var id = pathCollection.join('/');
		//
		if (to.query.scrollto) {
			next({ query: { scrollto: to.query.scrollto } });
		}
		//
		if (to.path != from.path) {
			fetch(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* ABSPATH */] + '/' + id).then(function (response) {
				return response.json();
			}).then(function (body) {
				__WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].commit('insertPage', body);
				next(true);
			}).catch(next(false));
		}
	},
	mounted: function mounted() {
		this.scrollToAnchor();
	}
});

/***/ }),

/***/ "B/qg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.content.slider),function(slider){return _c('div',{staticClass:"swiper-slide"},[_c('div',{staticClass:"slide-inner"},[_c('img',{attrs:{"src":slider.icon}}),_c('h3',[_vm._v(_vm._s(slider.copy))])])])}))]),_c('div',{staticClass:"swiper-pagination"}),_c('div',{staticClass:"swiper-button-prev"}),_c('div',{staticClass:"swiper-button-next"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CNtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('span',{staticClass:"hero-scrollto",on:{"click":function($event){_vm.scrollTo2nd()}}}),_c('div',{staticClass:"hero-logo"},[(_vm.content.logo === 'true')?_c('Logo',{staticClass:"icon"}):_vm._e()],1),_c('div',{staticClass:"hero-wrapper"},[_c('div',{staticClass:"hero-video-width"},[_c('div',{staticClass:"hero-video-aspect"},[_c('div',{staticClass:"hero-video-height"},[_c('iframe',{attrs:{"src":'https://player.vimeo.com/video/'+_vm.content.video_id+'/?title=0&byline=0&background=1&portrait=1&autoplay=1&loop=1',"width":"1600","height":"900","frameborder":"0","webkitallowfullscreen":"webkitallowfullscreen","mozallowfullscreen":"mozallowfullscreen","allowfullscreen":"allowfullscreen"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DDaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js__ = __webpack_require__("gsqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Slider',
	props: ['content'],
	data: function data() {
		return {
			slider: null,
			settings: {
				speed: 600,
				loop: false,
				slidesPerView: 5,
				spaceBetween: 0,
				autoHeight: true,
				pagination: {
					el: '.slider .swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.slider .swiper-button-next',
					prevEl: '.slider .swiper-button-prev'
				},
				breakpoints: {
					1100: {
						slidesPerView: 4
					},
					960: {
						slidesPerView: 3
					},
					560: {
						slidesPerView: 1
					}
				}
			}
		};
	},

	methods: {
		initSlider: function initSlider() {
			this.slider = new __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js___default.a('.slider .swiper-container', this.settings);
		}
	},
	mounted: function mounted() {
		this.initSlider();
	}
});

/***/ }),

/***/ "DR8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Navmain',
	data: function data() {
		return {
			newRoute: null,
			newPath: null
		};
	},

	computed: {
		menu: function menu() {
			return __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].state.menu;
		}
	},
	methods: {
		togglemenu: function togglemenu(e) {
			e.preventDefault();
			var body = document.querySelector('#header');
			if (body.classList.contains('is_open')) {
				body.classList.remove('is_open');
			} else {
				body.classList.add('is_open');
			}
		},
		openmenu: function openmenu(e) {
			e.preventDefault();
			var body = document.querySelector('#header');
			body.classList.add('is_open');
		},
		closemenu: function closemenu(e) {
			if (e) e.preventDefault();
			var body = document.querySelector('#header');
			body.classList.remove('is_open');
		},
		updateMenu: function updateMenu(to) {
			// var data = Object.assign({}, this.$route.query);
			// data['scrollto'] = query;
			var anchor = document.querySelector('#' + to) || null;
			if (anchor) this.$parent.winScrollTo(anchor);
			this.$router.push({ name: 'Page', query: { scrollto: to } });
			this.closemenu();
		},

		initStickyMenu: function initStickyMenu() {
			var $_header = this.$el,
			    _topP = $_header.offsetTop,
			    _scrollTop = _topP + $_header.offsetHeight,
			    _scrollOuter = _scrollTop * 2,
			    _scrolled = _scrollOuter * 2;

			window._isScrolled = {};
			window._isScrolled.one = false;
			window._isScrolled.two = false;
			window._isScrolled.three = false;

			var ifStickyHasClass = function ifStickyHasClass(item, classname) {
				var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'add';

				if (add === 'remove') {
					if (item.classList.contains(classname)) {
						item.classList.remove(classname);
					}
				} else {
					if (!item.classList.contains(classname)) {
						item.classList.add(classname);
					}
				}
			};

			var initStickyStatus = function initStickyStatus(sTop, pOuter, pScrolled) {
				var _scrollY = window.pageYOffset || document.documentElement.scrollTop;

				if (_scrollY > sTop && !window._isScrolled.one) {
					ifStickyHasClass($_header, 'fixed');
					window._isScrolled.one = true;
				}
				if (_scrollY > pOuter && !window._isScrolled.two) {
					ifStickyHasClass($_header, 'sticky-menu');
					window._isScrolled.two = true;
				}
				if (_scrollY > pScrolled && !window._isScrolled.three) {
					ifStickyHasClass($_header, 'scrolled');
					window._isScrolled.three = true;
				}

				if (_scrollY < pScrolled && window._isScrolled) {
					ifStickyHasClass($_header, 'scrolled', 'remove');
					window._isScrolled.three = false;
				}
				if (_scrollY < pOuter && window._isScrolled) {
					ifStickyHasClass($_header, 'sticky-menu', 'remove');
					window._isScrolled.two = false;
				}
				if (_scrollY < sTop && window._isScrolled) {
					ifStickyHasClass($_header, 'fixed', 'remove');
					window._isScrolled.one = false;
				}
			};

			initStickyStatus(_scrollTop, _scrollOuter, _scrolled);
			window.addEventListener('scroll', function () {
				initStickyStatus(_scrollTop, _scrollOuter, _scrolled);
			});
		}
	},
	mounted: function mounted() {
		this.initStickyMenu();
	}
});

/***/ }),

/***/ "DurA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XObm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e53e5e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("UevQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e53e5e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E+l5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Details',
	props: ['content']
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABSPATH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




// Set absolute location path
var ORIGIN = window.location.origin;
var LOCATION = '//kamerad-film.test';
if (ORIGIN.indexOf('localhost') === -1) LOCATION = ORIGIN + '/cms';
var ABSPATH = LOCATION;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	debug: true,
	state: {
		title: 'Kamerad Film',
		loadedSetup: false,
		loadedPage: false,
		loadedOverlay: false,
		//
		vimeo: [],
		menu: {},
		menufooter: {},
		header: {},
		content: {},
		overlayer: {}
	},
	mutations: {
		insertSetup: function insertSetup(state, value) {
			state.loadedSetup = true;
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'title', value.title);
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'menu', value.menu);
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'menufooter', value.menufooter);
		},
		insertPage: function insertPage(state, value) {
			state.loadedPage = true;
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'header', value.header);
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'content', value.content);

			document.title = value.header.name;
		},
		fetchVimeo: function fetchVimeo(state, value) {
			// if (state.vimeo.length >= value.length ) return
			var thumbs = [];
			console.log("state vimeo >", state.vimeo.length, value.length);
			__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(value, function (mov, k) {
				fetch('http://vimeo.com/api/v2/video/' + mov.id + '.json').then(function (response) {
					return response.json();
				}).then(function (movData) {
					thumbs.push(movData[0]);
				}).catch(function () {
					console.log('Error: JSON not found!');
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'vimeo', thumbs);
		},
		resultContent: function resultContent(state) {
			console.log('resultContent');
			return state.content;
		},
		setOverlayerDom: function setOverlayerDom(state, value) {
			state.overlayer = value;
		}
	}

});

/* harmony default export */ __webpack_exports__["b"] = (store);

/***/ }),

/***/ "LAxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("QZJ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b456e87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("f63S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b456e87_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lw4g":
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"253","height":"101","viewBox":"0 0 253 101","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_v("Untitled")]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M12.571 73.265l-4.12-13.423h-1.19v13.423H.508V41.407h6.711v12.7h1.402l4.035-12.7h7.306l-5.14 15.292 5.31 16.566h-7.561M30.857 50.922l-1.402 10.109h3.738l-1.401-10.109-.383-3.441h-.127l-.425 3.441zm3.186 16.566h-5.48l-.807 5.777h-7.009l6.245-31.858h8.92l6.371 31.858H34.85l-.807-5.777zM51.373 41.407l3.738 15.716.722 3.356h.127l.722-3.356 3.823-15.716h7.689v31.858h-6.202V60.139l.085-3.44-.127-.043-.765 3.398-3.228 13.211h-4.333l-3.186-13.168-.764-3.398-.085.042.042 3.441v13.083h-5.777V41.407h7.519M86.67 66.723l-.127 6.542H71.336V41.407h14.74l.127 6.669H78.09v5.607h6.626v6.329H78.09v6.711h8.58M97.162 47.778h-1.529v7.434h1.529c1.869 0 2.506-.425 2.506-3.653 0-3.143-.637-3.781-2.506-3.781zm10.704 25.487h-7.561l-3.058-12.276h-1.614v12.276h-6.754V41.407h7.858c6.796 0 9.855 2.633 9.855 9.94 0 4.247-1.062 7.051-3.144 8.24l4.418 13.678zM118.442 50.922l-1.402 10.109h3.738l-1.401-10.109-.383-3.441h-.127l-.425 3.441zm3.186 16.566h-5.48l-.807 5.777h-7.009l6.245-31.858h8.92l6.371 31.858h-7.433l-.807-5.777zM139.977 47.991h-1.784v18.775h1.827c2.463 0 3.398-.807 3.398-9.77 0-7.986-.807-9.005-3.441-9.005zm-.042 25.274h-8.496V41.407h8.241c7.646 0 10.789 3.483 10.789 15.674 0 12.148-3.101 16.184-10.534 16.184zM201.561 73.27h6.967V41.412h-6.967zM226.24 66.601l-.212 6.669h-14.103V41.412h6.882v25.189h7.433M235.669 41.412l3.738 15.717.722 3.355h.128l.722-3.355 3.823-15.717h7.688V73.27h-6.201V60.145l.085-3.441-.128-.043-.764 3.399-3.229 13.21h-4.332l-3.186-13.168-.765-3.398-.085.042.043 3.441V73.27h-5.777V41.412h7.518M191.282 48.166h7.986l-.085-6.754h-8.758c-.328.731-1.516 3.317-2.215 4.124-.944 1.087-2.903 4.059-3.283 4.81a5.665 5.665 0 0 1-.399.592V73.27h6.754V60.952h6.669l.042-6.542h-6.711v-6.244"}}),_c('path',{attrs:{"d":"M4.875 82.535v.183c0 1.281-.867 2.081-2.159 2.081-1.31 0-2.216-.809-2.216-2.11v-2.303c0-1.3.8-2.11 2.216-2.11 1.292 0 2.159.8 2.159 2.081v.155H3.719v-.145c0-.607-.376-1.012-1.022-1.012-.617 0-.993.415-.993 1.051v2.264c0 .636.376 1.05.993 1.05.646 0 1.022-.405 1.022-1.012v-.173h1.156M7.044 82.67c0 .636.376 1.05 1.031 1.05.646 0 1.022-.414 1.022-1.05v-2.264c0-.636-.376-1.051-1.022-1.051-.655 0-1.031.415-1.031 1.051v2.264zm3.257.019c0 1.301-.905 2.11-2.226 2.11-1.33 0-2.236-.809-2.236-2.11v-2.303c0-1.3.8-2.11 2.236-2.11 1.321 0 2.226.81 2.226 2.11v2.303zM15.863 84.703h-.983l-2.246-3.999v3.999h-1.099v-6.33h1.032l2.197 3.902v-3.902h1.099v6.33M21.472 82.535v.183c0 1.281-.867 2.081-2.159 2.081-1.311 0-2.217-.809-2.217-2.11v-2.303c0-1.3.8-2.11 2.217-2.11 1.292 0 2.159.8 2.159 2.081v.155h-1.157v-.145c0-.607-.375-1.012-1.021-1.012-.617 0-.993.415-.993 1.051v2.264c0 .636.376 1.05.993 1.05.646 0 1.021-.405 1.021-1.012v-.173h1.157M23.814 82.014v1.609h2.737v1.08h-3.942v-6.33h3.855v1.079h-2.65v1.503h2.371v1.059h-2.371M28.874 79.423v2.071h.896c.665 0 1.07-.404 1.07-1.04 0-.626-.405-1.031-1.07-1.031h-.896zm-1.205-1.05h2.207c1.263 0 2.188.819 2.188 2.052 0 1.301-.925 2.12-2.188 2.12h-1.002v2.158h-1.205v-6.33zM32.507 78.373h4.232v1.079h-1.514v5.251H34.03v-5.251h-1.523v-1.079M39.273 85.772h1.108v-8.44h-1.108zM47.862 82.535v.183c0 1.281-.867 2.081-2.159 2.081-1.311 0-2.217-.809-2.217-2.11v-2.303c0-1.3.8-2.11 2.217-2.11 1.292 0 2.159.8 2.159 2.081v.155h-1.156v-.145c0-.607-.376-1.012-1.022-1.012-.617 0-.993.415-.993 1.051v2.264c0 .636.376 1.05.993 1.05.646 0 1.022-.405 1.022-1.012v-.173h1.156M50.03 82.67c0 .636.376 1.05 1.032 1.05.645 0 1.021-.414 1.021-1.05v-2.264c0-.636-.376-1.051-1.021-1.051-.656 0-1.032.415-1.032 1.051v2.264zm3.258.019c0 1.301-.906 2.11-2.226 2.11-1.33 0-2.236-.809-2.236-2.11v-2.303c0-1.3.8-2.11 2.236-2.11 1.32 0 2.226.81 2.226 2.11v2.303zM55.727 79.423v1.907h.896c.665 0 1.07-.375 1.07-.963 0-.578-.405-.944-1.07-.944h-.896zm1.918 5.28l-.916-2.322h-1.002v2.322h-1.205v-6.33h2.226c1.253 0 2.169.78 2.169 1.965 0 .819-.386 1.436-1.003 1.763l1.041 2.602h-1.31zM61.259 79.423v2.071h.896c.665 0 1.07-.404 1.07-1.04 0-.626-.405-1.031-1.07-1.031h-.896zm-1.205-1.05h2.207c1.263 0 2.188.819 2.188 2.052 0 1.301-.925 2.12-2.188 2.12h-1.002v2.158h-1.205v-6.33zM66.463 82.67c0 .636.376 1.05 1.032 1.05.645 0 1.021-.414 1.021-1.05v-2.264c0-.636-.376-1.051-1.021-1.051-.656 0-1.032.415-1.032 1.051v2.264zm3.258.019c0 1.301-.906 2.11-2.226 2.11-1.33 0-2.236-.809-2.236-2.11v-2.303c0-1.3.8-2.11 2.236-2.11 1.32 0 2.226.81 2.226 2.11v2.303zM72.159 79.423v1.907h.897c.665 0 1.07-.375 1.07-.963 0-.578-.405-.944-1.07-.944h-.897zm1.918 5.28l-.915-2.322h-1.003v2.322h-1.204v-6.33h2.226c1.253 0 2.169.78 2.169 1.965 0 .819-.386 1.436-1.003 1.763l1.041 2.602h-1.311zM77.692 82.545h1.474l-.742-2.689-.732 2.689zm-1.754 2.158l1.888-6.33h1.273l1.889 6.33h-1.234l-.318-1.137h-2.014l-.309 1.137h-1.175zM80.911 78.373h4.231v1.079h-1.513v5.251h-1.195v-5.251h-1.523v-1.079M87.233 82.014v1.609h2.738v1.08h-3.942v-6.33h3.855v1.079h-2.651v1.503h2.371v1.059h-2.371M92.949 85.772h1.108v-8.44h-1.108zM101.537 82.535v.183c0 1.281-.867 2.081-2.159 2.081-1.31 0-2.216-.809-2.216-2.11v-2.303c0-1.3.8-2.11 2.216-2.11 1.292 0 2.159.8 2.159 2.081v.155h-1.156v-.145c0-.607-.376-1.012-1.022-1.012-.617 0-.993.415-.993 1.051v2.264c0 .636.376 1.05.993 1.05.646 0 1.022-.405 1.022-1.012v-.173h1.156M103.706 82.67c0 .636.375 1.05 1.031 1.05.646 0 1.022-.414 1.022-1.05v-2.264c0-.636-.376-1.051-1.022-1.051-.656 0-1.031.415-1.031 1.051v2.264zm3.257.019c0 1.301-.906 2.11-2.226 2.11-1.33 0-2.236-.809-2.236-2.11v-2.303c0-1.3.8-2.11 2.236-2.11 1.32 0 2.226.81 2.226 2.11v2.303zM109.315 80.733v3.97h-1.118v-6.33h1.031l1.514 2.755 1.493-2.755h1.032v6.33H112.1v-3.941l-1.031 1.869h-.694l-1.06-1.898M115.792 80.733v3.97h-1.118v-6.33h1.031l1.513 2.755 1.494-2.755h1.031v6.33h-1.166v-3.941l-1.031 1.869h-.694l-1.06-1.898M122.355 82.014v1.609h2.738v1.08h-3.942v-6.33h3.855v1.079h-2.651v1.503h2.371v1.059h-2.371M127.415 79.423v1.907h.897c.665 0 1.069-.375 1.069-.963 0-.578-.404-.944-1.069-.944h-.897zm1.918 5.28l-.915-2.322h-1.003v2.322h-1.204v-6.33h2.226c1.253 0 2.168.78 2.168 1.965 0 .819-.385 1.436-1.002 1.763l1.041 2.602h-1.311zM135.945 82.535v.183c0 1.281-.868 2.081-2.159 2.081-1.311 0-2.217-.809-2.217-2.11v-2.303c0-1.3.8-2.11 2.217-2.11 1.291 0 2.159.8 2.159 2.081v.155h-1.157v-.145c0-.607-.376-1.012-1.021-1.012-.617 0-.993.415-.993 1.051v2.264c0 .636.376 1.05.993 1.05.645 0 1.021-.405 1.021-1.012v-.173h1.157M137.082 84.703h1.205v-6.33h-1.205zM140.899 82.545h1.474l-.742-2.689-.732 2.689zm-1.754 2.158l1.889-6.33h1.272l1.889 6.33h-1.234l-.318-1.137h-2.014l-.308 1.137h-1.176zM146.258 83.623h2.476v1.08h-3.681v-6.33h1.205v5.25","fill":"#E05530"}}),_c('path',{attrs:{"d":"M185.807 33.254s-.037-.056-.234-.455c-.196-.399-.516-.737-1.284-1.788-.768-1.051-4.302-4.548-4.775-5.095-.473-.547-.405-.491-1.106-1.665-.701-1.174-3.398-3.03-5.348-4.109-1.951-1.08-3.159-.99-3.159-.99l-1.345-1.557s.093-.116.308-.319.971-.799 1.371-1.377c.399-.577.479-1.714.614-2.292.135-.577.265-1.032.443-1.26.178-.227.491-.786.547-1.001.055-.215-.16-.222-.338-.197-.179.025-.513.027-.513.027s.119-.5.23-.979c.111-.48.35-1.586.449-2.477.098-.891.086-1.082.123-1.838.036-.755.23-.872.23-.872s-.452-.518-.73-.961c-.279-.442-.787-1.36-1.229-1.802-.443-.443-1.639-1.246-3.704-1.688-2.065-.443-2.638.164-4.212.966-1.573.803-1.966 2.213-2.196 3.081-.229.869-.147 2.032-.065 3.147.082 1.114-.312 1.632-.312 1.632s-.106-.1-.524-.272c-.418-.172-.344-.017-.655.36-.312.377-.238.885-.156 1.074.082.188.213.688.352 1.385.14.696.361.753.541.983.18.229.197.303.352.778.156.476 1.103.517 1.103.517l1.36 5.406s-.275-.031-.857.018c-.581.049-1.114.573-1.418.78-.304.206-.089.014-1.728.899s-1.975 3.778-2.024 4.097c-.049.32-.41.852-.565 1.352-.156.5.147 1.197-.213 1.901-.361.705-.623 2.221-.697 2.942-.073.721-.36 1.081-.663 1.95-.304.869 2.738 3.799 2.738 3.799s-.034.044-.452.962c-.418.917-.738 2.482-.967 4.187-.23 1.704-.754 2.597-.967 3.13-.213.532-.803 3.957-.811 4.424-.008.467-.123 1.778-.049 2.18.073.401 1.065 1.876 1.065 1.876s.06.34.172.639c.196.525.008.341.893.877.5.303 2.438-.054 2.438-.054s.069.136.299.644c.229.508 1.57 1.064 1.57 1.064s-.054 8.154-.038 9.408c.016 1.253 1.051 1.248 1.051 1.248s-.01.054-.06.202c-.049.147-.311 1.278-.483 1.786s-.016.635-.016.635-.058.111-.402.734c-.344.622.066 2.04.172 2.531.107.492.124 1.638.124 1.638s-.124.149-.14.288c-.017.139-.197 2.343-.205 2.63-.008.287-.795 3.212-.975 4.089-.18.877-1.337 5.817-1.337 5.817-.236.805-1.928 3.2-1.928 3.2s-.163-.091-.404-.128c-.24-.037-.592.07-.805.185-.213.116-.582.898-.582.898s-.107-.046-.389-.066c-.281-.02-.297.061-.418.271-.121.209.214.438.214.438l-.028.079c-.028.079-.079.111-.268.143-.19.033-.204.084-.278.246-.074.161.004.532.004.532s-.062-.013-.234.012c-.172.024-.221.307-.258.577-.037.271-.074.136-.356.246-.283.111-.136.111-.197.455-.061.344-.147.455-.492.725-.344.271-.837.794-.837.794s-.06.017-.195.042-.283.135-.799.442c-.516.308-.602.885-.602.885l-.074.074c-.074.074-.098.418-.147.848-.05.43.036.492 1.278 1.217 1.241.725 3.331.528 5.187.221 1.855-.307 3.183-1.573 3.662-2.126.479-.553 1.155-.774 1.942-1.315.787-.541.615-1.475.565-1.881-.049-.405.025-.639-.147-1.511-.172-.873-.197-.517-.246-.799-.049-.283-.198-.334-.198-.334s.272-1.264.579-2.161c.307-.897.836-2.041 1.205-2.766.368-.725 1.769-3.355 2.47-4.99.701-1.634.959-4.486.959-5.395 0-.91.135-1.758.11-1.955-.024-.196-.184-.11-.184-.11s-.086-.75-.037-1.524c.049-.775.671-2.315.671-2.315s.632-.033 1.382-.156c.749-.123 1.044-.196 1.266-.307.221-.111.258.074.59.172.331.098 1.279.037 1.279.037s.712.664 1.13 1.143c.417.479 6.55 10.222 6.55 10.222s-.098.028-.258.09c-.159.061-.332.381-.577.737-.246.357-.431.344-.775.615-.344.27-.319 1.069-.442 1.635-.123.565-.479.7-.996 1.044-.516.344.034.37.034.37l-.039.196s-.351.049-.661.176c-.31.128-1.46.745-1.988 1.04-.529.295-.467.775-.369 1.635.098.86 1.561 1.254 3.454 1.106 1.892-.147 3.576-1.02 4.08-1.487.504-.467.737-.762 1.143-1.094.406-.332 2.532-1.647 3.564-2.397 1.033-.749 1.131-1.056 1.193-1.511.061-.455-.246-.971-.418-1.242-.172-.27-.349-.214-.349-.214s-.057-.117-.143-.351c-.086-.233-1.143-1.315-1.426-1.622-.282-.308-.398-.126-.398-.126s-1.101-1.484-1.568-2.455c-.467-.971-2.126-4.99-2.839-6.662-.713-1.671-3.179-2.839-3.179-2.839l.708-9.673.344-.233c.345-.234.879-.99.879-.99.633-.922.492-2.956.492-2.956l.473-.264c.292-.163 1.554-1.191 2.48-1.957.218.263.539.685.507.857-.05.258-.517.492-.308.897.209.406.676.811 1.34 1.217s.848.504.406 1.364c-.443.861-2.151 3.245-2.385 3.651-.233.405-.393.651-.332.872.062.221.345.443-.184 1.082-.528.639-2.36 3.724-2.667 4.314-.307.59-.488.795-.488.795s-.381-.107-.401.09c-.021.197-.119.344.459.663.577.32 1.524.861 1.622.873.098.013.344-.11.32-.319-.025-.209-.263-.209-.131-.529.131-.319 1.495-3.232 1.679-3.699.185-.467.934-2.078 1.033-2.79.098-.713-.123-.898.16-1.512.282-.615 1.511-2.36 1.696-2.741.184-.381.762-1.831.712-2.089-.049-.259-.352-1.049-.766-1.459-.413-.41-.917-.643-.93-1.11-.012-.467.222-.59-.209-1.119a18.484 18.484 0 0 1-.122-.15l.012-.009s1.321-1.358 1.856-2.028c.534-.67 1.18-2.329 2.009-3.38.83-1.051 2.618-3.927 3.263-5.291.646-1.365.584-2.514.689-2.907.104-.393.393-.332.516-.904.123-.571-4.308-4.51-4.308-4.51","fill":"#FFF"}})])])}}};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17921ab4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Y1FF");
function injectStyle (ssrContext) {
  __webpack_require__("soqg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17921ab4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_3__store__["b" /* default */],
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NX2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Navfooter',
	computed: {
		menu: function menu() {
			return __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].state.menu.footer;
		}
	}
});

/***/ }),

/***/ "PNLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.key.length > 0)?_c('div',{staticClass:"gallery"},[_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.content.key),function(item){return _c('div',{staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.image}})])}))]),(_vm.content.key.length > 1)?_c('div',{staticClass:"swiper-pagination"}):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logo_dark_svg__ = __webpack_require__("0B/E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logo_dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__logo_dark_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Columns',
	props: ['content'],
	methods: {
		matchPhoneNum: function matchPhoneNum(el) {
			return el.replace(/\s/g, '');
		}
	},
	components: {
		LogoDark: __WEBPACK_IMPORTED_MODULE_0__logo_dark_svg___default.a
	}
});

/***/ }),

/***/ "UevQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legals"},[_vm._l((_vm.menufooter),function(menu,index){return _c('a',{staticClass:"legals-link",on:{"click":function($event){$event.stopPropagation();_vm.toggleContent()}}},[_c('span',[_vm._v(_vm._s(menu.title))])])}),_c('div',{staticClass:"legals-content"},[_c('span',{staticClass:"legals-close",on:{"click":function($event){$event.stopPropagation();_vm.toggleContent()}}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.copy)}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W7Tg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"movies-icon"}),_c('div',{staticClass:"movies"},[_vm._l((_vm.thumbs),function(mov){return _c('p',[_vm._v(_vm._s(mov.id))])}),_c('div',{staticClass:"movies-grid columns is-multiline is-tablet"},_vm._l((_vm.content.grid),function(movie){return _c('div',{staticClass:"column is-half-tablet"},[_c('figure',[_c('a',{staticClass:"movies-link",on:{"click":function($event){$event.stopPropagation();_vm.setOverlayer(movie)}}}),(movie.thumb != '')?_c('img',{attrs:{"src":movie.thumb}}):_c('iframe',{attrs:{"src":'https://player.vimeo.com/video/'+movie.id+'/?title=0&byline=0&background=1&portrait=1&autoplay=0',"width":"1600","height":"1100","frameborder":"0","webkitallowfullscreen":"webkitallowfullscreen","mozallowfullscreen":"mozallowfullscreen","allowfullscreen":"allowfullscreen"}}),_c('div',{staticClass:"movies-details"},[_c('span'),_c('i'),_c('div',{staticClass:"movies-details-inner"},[_c('h4',[_vm._v(_vm._s(movie.title))]),_c('p',[_vm._v(_vm._s(movie.copy))])])])])])}))],2),_c('div',{staticClass:"movies-banderole"},[_c('a',{attrs:{"href":'https://vimeo.com/' + _vm.content.link_id,"target":"_blank"}},[_vm._v("Mehr Filme auf Vimeo")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WoGI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'NotFound'
});

/***/ }),

/***/ "XObm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Legals',
	props: ['content'],
	computed: {
		menufooter: function menufooter() {
			return __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].state.menufooter;
		}
	},
	methods: {
		toggleContent: function toggleContent() {
			var content = this.$el.querySelector('.legals-content');
			content.classList.toggle('is-open');
			if (content.classList.contains('is-open')) {
				this.$parent.$parent.winScrollTo(this.$el.parentNode);
			}
		}
	}
});

/***/ }),

/***/ "Y1FF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('navmain'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path,staticClass:"view"})],1),_c('overlayer'),_c('navfooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YUD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',{staticClass:"errorpage"},[_c('div',{staticClass:"details"},[_c('span',[_vm._v("404 Error")]),_c('h1',[_vm._v("Oops, something went wrong!")]),_c('p',[_vm._v("We can't seem to find the page you're looking for.\nGo to our "),_c('a',{attrs:{"href":"/","title":"Back to home page"}},[_vm._v("home page")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("pMNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NotFound__ = __webpack_require__("YcJa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var Router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	base: __dirname,
	routes: [{
		path: '/',
		name: 'Page',
		component: __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */]
	}, {
		path: '*',
		component: __WEBPACK_IMPORTED_MODULE_3__components_NotFound__["a" /* default */]
	}]
	// scrollBehavior(to, from, savedPosition) {
	// 	console.log('scrollBehavior');
	// 	console.log(to);
	// 	console.log(from);
	// 	console.log(savedPosition);
	//
	// 	if (savedPosition) {
	//     return savedPosition
	//   } else {
	//     const position = {}
	//
	//     // scroll to anchor by returning the selector
	//     if (to.hash) {
	//       position.selector = to.hash
	//
	//       if (document.querySelector(to.hash)) {
	//         return position
	//       }
	//
	//       // if the returned position is falsy or an empty object,
	//       // will retain current scroll position.
	//       return false
	//     }
	//
	//     return new Promise(resolve => {
	//       // check if any matched route config has meta that requires scrolling to top
	//       if (to.matched.some(m => m.meta.scrollToTop)) {
	//         // coords will be used if no selector is provided,
	//         // or if the selector didn't match any element.
	//         position.x = 0
	//         position.y = 0
	//       }
	//
	//       // wait for the out transition to complete (if necessary)
	//       // this.app.$root.$once('triggerScroll', () => {
	//       //   // if the resolved position is falsy or an empty object,
	//       //   // will retain current scroll position.
	//       //   resolve(position)
	//       // })
	//     })
	//   }
	// }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("WoGI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473711f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("YUD4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_473711f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aoQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("mw2P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb2e43d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("W7Tg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb2e43d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "co6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("DR8V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70824e63_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("ruiD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70824e63_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dG7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlayer"},[_c('div',{staticClass:"overlayer-background",on:{"click":function($event){$event.stopPropagation();_vm.close()}}}),_c('div',{staticClass:"overlayer-wrapper"},[_c('div',{staticClass:"overlayer-close",on:{"click":function($event){$event.stopPropagation();_vm.close()}}}),_c('div',{staticClass:"overlayer-body"},[_c('div',{staticClass:"overlayer-inner",domProps:{"innerHTML":_vm._s(_vm.insertDom)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e0hc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lwBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b20552_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("CNtD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b20552_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f63S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"contact-cols"},_vm._l((_vm.content.key),function(column){return _c('div',{staticClass:"contact-cols-item"},[_c('figure',{class:column.type},[(column.info)?[_c('img',{attrs:{"src":column.info.img}}),_c('h3',[_vm._v(_vm._s(column.info.name))]),_c('p',[_vm._v(_vm._s(column.info.copy))])]:[_c('LogoDark',{staticClass:"contact-logo"}),_c('p',[_vm._v(_vm._s(column.detail.title)+" "),_c('br'),_vm._v("\n"+_vm._s(column.detail.street)+" "),_c('br'),_vm._v("\n"+_vm._s(column.detail.city))]),_c('p',[_c('a',{attrs:{"href":'tel:' + _vm.matchPhoneNum(column.detail.phone)}},[_vm._v(_vm._s(column.detail.phone))]),_c('br'),_c('a',{attrs:{"href":'mailto:' + column.detail.mail}},[_vm._v(_vm._s(column.detail.mail))])]),_c('div',{staticClass:"contact-socials"},_vm._l((column.detail.socials),function(item, index){return _c('a',{class:index,attrs:{"href":item,"title":index,"target":"_blank"}})}))]],2)])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hVVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js__ = __webpack_require__("gsqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Gallery',
	props: ['content'],
	data: function data() {
		return {
			slider: null,
			settings: {
				speed: 600,
				loop: false,
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: false,
				pagination: {
					clickable: true
				}
			}
		};
	},

	methods: {
		initSlider: function initSlider() {
			this.settings.pagination.el = '.gallery .swiper-pagination';
			this.slider = new __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js___default.a('.gallery .swiper-container', this.settings);
		}
	},
	mounted: function mounted() {
		var _this = this;

		// console.log(this.content);
		setTimeout(function () {
			return _this.initSlider();
		}, 20);
	}
});

/***/ }),

/***/ "i2i7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js__ = __webpack_require__("gsqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Logoslider',
	props: ['content'],
	data: function data() {
		return {
			slider: null,
			settings: {
				speed: 600,
				loop: false,
				autoplay: {
					delay: 2000
				},
				slidesPerView: 3,
				spaceBetween: 0,
				autoHeight: true,
				pagination: {
					clickable: true
				},
				navigation: {}
			}
		};
	},

	methods: {
		initSlider: function initSlider() {
			var _this = this;

			if (this.slider == null) {
				setTimeout(function () {
					_this.settings.pagination.el = '.logoslider .swiper-pagination';
					_this.slider = new __WEBPACK_IMPORTED_MODULE_0_swiper_dist_js_swiper_js___default.a('.logoslider .swiper-container', _this.settings);
				}, 50);
			}
		},
		destroySlider: function destroySlider() {
			if (this.slider != null) {
				this.slider.destroy(true);
				this.slider = null;
			}
		},
		toggleSliderOnResize: function toggleSliderOnResize() {
			var breakpoint = window.matchMedia("(min-width: 480px)");

			if (breakpoint.matches) {
				this.destroySlider();
			} else {
				this.initSlider();
			}
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		window.addEventListener('resize', function () {
			return _this2.toggleSliderOnResize();
		});
		this.toggleSliderOnResize();
	}
});

/***/ }),

/***/ "j2gS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoslider"},[_c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.content.logos),function(logo){return _c('div',{staticClass:"swiper-slide"},[_c('figure',[_c('div',[_c('img',{attrs:{"src":logo.img}})])])])}))]),_c('div',{staticClass:"swiper-pagination"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8E0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overlayer_vue__ = __webpack_require__("4L5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df66984_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Overlayer_vue__ = __webpack_require__("dG7L");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df66984_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Overlayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lOOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.content.surtitle != '')?_c('span',[_vm._v(_vm._s(_vm.content.surtitle))]):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.content.headline))]),(_vm.content.copy != '')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.copy)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lwBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logo_svg__ = __webpack_require__("Lw4g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__logo_svg__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Hero',
	props: ['content'],
	components: {
		Logo: __WEBPACK_IMPORTED_MODULE_0__logo_svg___default.a
	},
	methods: {
		changeVideoOnScroll: function changeVideoOnScroll() {
			var dom = this.$el.querySelector('.hero-wrapper'),
			    scrollActive = false,
			    winPos = void 0,
			    winH = void 0;

			window.addEventListener('scroll', function () {
				winPos = window.scrollY || window.pageYOffset;
				winH = window.innerHeight;
				if (winPos > winH && !scrollActive) {
					scrollActive = true;
					dom.style.visibility = 'hidden';
				} else if (winPos < winH && scrollActive) {
					scrollActive = false;
					dom.style.visibility = '';
				}
			});
		},
		videoPropFullsize: function videoPropFullsize() {
			var timeoutId,
			    $videoBgAspect = document.querySelector(".hero-video-aspect"),
			    $videoBgWidth = document.querySelector(".hero-video-width"),
			    videoAspect = $videoBgAspect.offsetHeight / $videoBgAspect.offsetWidth;

			var videoEnlarge = function videoEnlarge() {
				var windowAspect = window.innerHeight / window.innerWidth;
				if (windowAspect > videoAspect) {
					$videoBgWidth.style.width = windowAspect / videoAspect * 100 + '%';
				} else {
					$videoBgWidth.style.width = 100 + "%";
				}
			};

			window.addEventListener('resize', function () {
				clearTimeout(timeoutId);
				timeoutId = setTimeout(videoEnlarge, 80);
			});
			videoEnlarge();
		},
		scrollTo2nd: function scrollTo2nd() {
			this.$parent.$parent.winScrollTo(this.$parent.$el.children[1]);
		}
	},
	mounted: function mounted() {
		this.changeVideoOnScroll();
		this.videoPropFullsize();
	}
});

/***/ }),

/***/ "mw2P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Movies',
	props: ['content'],
	computed: {
		thumbs: function thumbs() {
			// store.commit('fetchVimeo', this.content.grid);
			// return store.state.vimeo;
		}
	},
	methods: {
		setOverlayer: function setOverlayer(item) {
			var iframe = '\n\t\t\t\t<div class="video-container">\n\t\t\t\t\t<h3>' + item.title + '</h3>\n\t\t\t\t\t<div class="video-frame">\n\t\t\t\t\t\t<iframe src="https://player.vimeo.com/video/' + item.id + '/?title=0&byline=0&autoplay=1"\n\t\t\t\t\t\t\twidth="1600"\n\t\t\t\t\t\t\theight="900"\n\t\t\t\t\t\t\tframeborder="0"\n\t\t\t\t\t\t\twebkitallowfullscreen mozallowfullscreen allowfullscreen>\n\t\t\t\t\t\t</iframe>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>' + item.details + '</p>\n\t\t\t\t</div>';
			__WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].commit('setOverlayerDom', iframe);
			this.$parent.$parent.openOverlayer();
		}
	}
});

/***/ }),

/***/ "pMNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__("AO5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed444bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__("7IiW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed444bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ruiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header","role":"banner"}},[_c('div',{staticClass:"togglemenu",on:{"click":_vm.togglemenu}},[_c('span')]),_c('nav',{staticClass:"nav-holder",attrs:{"role":"navigation"}},[_c('ul',{staticClass:"menu"},_vm._l((_vm.menu),function(item,index){return _c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":'/?scrollto='+item.key}},[_c('span',{on:{"click":function($event){_vm.updateMenu(item.key)}}},[_vm._v(_vm._s(item.title))])])],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s9je":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NX2X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0650ed30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("6x5o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0650ed30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "soqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs__ = __webpack_require__("A5qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_features_Navmain___ = __webpack_require__("co6c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_features_Navfooter___ = __webpack_require__("s9je");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Overlayer__ = __webpack_require__("j8E0");

//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {
			dom: {
				overlayer: {}
			}
		};
	},
	created: function created() {
		this.fetchData();
	},

	components: {
		navmain: __WEBPACK_IMPORTED_MODULE_3__components_features_Navmain___["a" /* default */],
		navfooter: __WEBPACK_IMPORTED_MODULE_4__components_features_Navfooter___["a" /* default */],
		overlayer: __WEBPACK_IMPORTED_MODULE_5__components_Overlayer__["a" /* default */]
	},
	methods: {
		fetchData: function fetchData() {
			if (!__WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].state.loadedSetup) {
				// console.log('state');
				fetch(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* ABSPATH */] + '/api/v1/setup').then(function (response) {
					return response.json();
				}).then(function (body) {
					__WEBPACK_IMPORTED_MODULE_2__store__["b" /* default */].commit('insertSetup', body);
				}).catch(function (error) {
					console.log('error', error);
				});
			}
		},
		winScrollTo: function winScrollTo(to) {
			var scrollType = (typeof to === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(to)) === 'object' ? to.offsetTop : to;
			var scrollAnim = __WEBPACK_IMPORTED_MODULE_1_animejs___default()({
				targets: 'html, body',
				scrollTop: scrollType,
				duration: 900,
				easing: 'easeInOutQuart'
			});
		},
		openOverlayer: function openOverlayer() {
			this.dom.overlayer.classList.add('overlayer--show');
			document.body.classList.add('is-overlayer');
		},
		closeOverlayer: function closeOverlayer() {
			this.dom.overlayer.classList.remove('overlayer--show');
			document.body.classList.remove('is-overlayer');
		}
	},
	mounted: function mounted() {
		this.dom.overlayer = this.$el.querySelector('.overlayer');
	}
});

/***/ }),

/***/ "xMj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("DDaC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d00da40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("B/qg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d00da40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xjBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("hVVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb3b2cb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("PNLF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb3b2cb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9a61eed6c913e64454f7.js